<template>
  <div>
    <div>
      <div class="row">
        <div
          class="col-md-3 col-sm-12"
          v-for="(fileType, index) in fileTypes"
          :key="index"
        >
          <Folder :file="fileType" />
        </div>
      </div>
      <hr />
      <div class="filters-area mb-4">
        <div class="row WrapFilter">
          <div class="col-12">
            <input
              type="text"
              class="form-control searchbar"
              placeholder="Cerca..."
              v-on:input="debounceInput"
              v-model="name"
            />
          </div>
          <div class="col-md-3">
            <select class="form-control" v-model="tag" @change="getData()">
              <option value="all">Tutti i tag</option>
              <option :value="tg.uuid" v-for="(tg, index) in tags" :key="index">
                {{ tg.value }}
              </option>
            </select>
          </div>
          <div class="col-md-3">
            <select class="form-control" v-model="category" @change="getData()">
              <option value="all">Tutte le categorie</option>
              <option
                :value="ct.uuid"
                v-for="(ct, index) in categories"
                :key="index"
              >
                {{ ct.value }}
              </option>
            </select>
          </div>
          <div class="col-md-3">
            <select class="form-control" v-model="year" @change="getData()">
              <option value="all">Tutti gli anni</option>
              <option
                :value="yr.uuid"
                v-for="(yr, index) in years"
                :key="index"
              >
                {{ yr.value }}
              </option>
            </select>
          </div>
          <div class="col-md-3">
            <select class="form-control" v-model="brand" @change="getData()">
              <option value="all">Tutti i brand</option>
              <option
                :value="br.uuid"
                v-for="(br, index) in brands"
                :key="index"
              >
                {{ br.value }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="text-center" v-if="loading">
        <b-spinner label="Spinning"></b-spinner>
      </div>
      <Drive
        :files="files"
        v-if="!loading"
        @deleted="getData()"
        @edit="openEditFileDialog($event)"
        @thumbnail="openFileThumbnailDialog($event)"
      />
    </div>

    <FileThumbnailDialog :url="fileThumbnail"/>

    <UploadFileDialog
      :categories="categories"
      :fileTypes="fileTypes"
      :years="years"
      :brands="brands"
      :tags="tags"
      @uploaded="getData()"
      @newElement="handleNewElement($event)"
    />

    <EditFileDialog
      :categories="categories"
      :fileTypes="fileTypes"
      :years="years"
      :brands="brands"
      :tags="tags"
      :file="selectedFile"
      @edited="getData()"
    />

    <button
      class="btn btn-primary"
      @click="openUploadFileDialog()"
      id="upload-file"
    >
      <i class="fas fa-upload"></i>
    </button>
  </div>
</template>

<script>
import FileTypesService from "@/services/file-types";
import YearsService from "@/services/years";
import CategoriesService from "@/services/categories";
import FilesService from "@/services/files";
import BrandsService from "@/services/brands";
import TagsService from "@/services/tags";

import Tree from "@/pages/dashboard/components/Tree";
import Drive from "@/pages/dashboard/components/Drive";
import Folder from "@/pages/dashboard/components/Folder";

import _ from "lodash";

export default {
  data() {
    return {
      loading: false,
      fileTypes: [],
      categories: [],
      brands: [],
      files: [],
      years: [],
      tags: [],
      category: "all",
      year: "all",
      brand: "all",
      tag: "all",
      name: "",
      selectedFile: null,
      fileThumbnail: null
    };
  },
  components: {
    Tree,
    Drive,
    Folder,
  },
  methods: {
    async getFileTypes() {
      const { docs } = await FileTypesService.getFileTypes(this.$db);
      const fileTypes = docs.map((doc) => doc.data());

      this.fileTypes = fileTypes;
    },

    async getTags() {
      const { docs } = await TagsService.getTags(this.$db);
      const tags = docs.map((doc) => doc.data());

      this.tags = tags;
    },

    async getYears() {
      const { docs } = await YearsService.getYears(this.$db);
      const years = docs.map((doc) => doc.data());

      this.years = years.sort((a, b) => a.value - b.value);
    },

    async getCategories() {
      const { docs } = await CategoriesService.getCategories(this.$db);
      const categories = docs.map((doc) => doc.data());

      this.categories = categories;
    },

    async getBrands() {
      const { docs } = await BrandsService.getBrands(this.$db);
      const brands = docs.map((doc) => doc.data());

      this.brands = brands;
    },

    async getData() {
      try {
        this.loading = true;

        const filters = {
          category: this.category !== "all" ? this.category : null,
          tag: this.tag !== "all" ? this.tag : null,
          brand: this.brand !== "all" ? this.brand : null,
          year: this.year !== "all" ? this.year : null,
        };
        const { docs } = await FilesService.getFiles(this.$db, filters);
        const files = docs.map((doc) => doc.data());

        if (this.name.trim() !== "") {
          this.files = files.filter((file) =>
            file.fileName.toLowerCase().includes(this.name.toLowerCase())
          );
        } else {
          this.files = files;
        }
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },

    openUploadFileDialog() {
      this.$root.$emit("bv::show::modal", "upload-file-modal");
    },

    openFileThumbnailDialog(url) {
      this.fileThumbnail = url;

      this.$root.$emit("bv::show::modal", "file-thumbnail-modal");
    },

    openEditFileDialog(file) {
      this.selectedFile = file;

      this.$root.$emit("bv::show::modal", "edit-file-modal");
    },

    debounceInput: _.debounce(function () {
      this.getData();
    }, 500),

    handleNewElement(element) {
      switch (element) {
        case 'tag': {
          this.getTags();
          break;
        }
        case 'type': {
          this.getFileTypes();
          break;
        }
        case 'category': {
          this.getCategories();
          break;
        }
        case 'year': {
          this.getYears();
          break;
        }
        case 'brand': {
          this.getBrands();
          break;
        }
      }
    }
  },
  mounted() {
    this.$store.dispatch("utils/setSectionName", "Archivio");

    this.getFileTypes();
    this.getCategories();
    this.getYears();
    this.getBrands();
    this.getTags();
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
#upload-file {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  position: fixed;
  bottom: 20px;
  right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/DashboardPage.vue